<app-loader-page *ngIf="areTablesLoading" [isloading]="areTablesLoading">
</app-loader-page>

<form *ngIf="!areTablesLoading" [formGroup]="userDetails" id="user-details" (ngSubmit)=onSubmit(userDetails)>
    <div class="d-flex flex-column justify-content-center text-center m-step-wrapper1 container"
        [ngClass]="{'first-question' : !prevQID}">
        <questions-manager [(editQid)]="qID" [visibleQids]="visibleQids" [(editQuestion)]="editQuestion"
            (editQuestionChange)="editQuestionChange($event)">
            <question [qID]="'1'">
                <div class="d-flex flex-column mt-md-0 mt-5">
                    <div class="mb-4 text-md-right text-center mr-md-3 mr-sm-1">
                        <h1 class="app-title-xxxlarge-blue d-md-inline" *ngIf="isAdvisor">{{
                            'USER_DETAILS.Q1.QUESTION_ADVISORS' | translate }}</h1>
                        <h1 class="app-title-xxxlarge-blue d-md-inline" *ngIf="!isAdvisor">{{
                            'USER_DETAILS.Q1.QUESTION1' | translate }}</h1>
                        <h1 class="app-title-xxxlarge-blue d-md-inline"> {{ 'USER_DETAILS.Q1.QUESTION2' | translate }}
                        </h1>
                    </div>
                    <div
                        class="row justify-content-lg-start justify-content-md-start justify-content-sm-center justify-content-center mb-4 mx-md-0 mx-4">
                        <!--text field-->
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-md-0 mb-4 input-wrapper"
                            aria-live="assertlive">
                            <app-animated-input formControlName="firstName"
                                placeholder="{{ 'USER_DETAILS.Q1.INPUT1_PH' | translate }}" [animatedLabel]="true"
                                [attAriaLabel]="'USER_DETAILS.Q1.INPUT1_PH'|translate" #firstName></app-animated-input>
                            <label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
                                *ngIf="userDetails.get('firstName').hasError('required') && submitted" role="alert">{{
                                'USER_DETAILS.Q1.REQUIRED1' | translate }}</label>
                            <label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
                                *ngIf="userDetails.get('firstName').hasError('pattern') && submitted" role="alert">{{
                                'COMMON.GENERAL_PATTERN_ERROR' | translate }}</label>
                        </div>
                        <!--text field-->
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12 input-wrapper" aria-live="assertlive">
                            <app-animated-input formControlName="lastName"
                                placeholder="{{ 'USER_DETAILS.Q1.INPUT2_PH' | translate }}" [animatedLabel]="true"
                                [attAriaLabel]="'USER_DETAILS.Q1.INPUT2_PH'|translate" #lastName></app-animated-input>
                            <label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
                                *ngIf="userDetails.get('lastName').hasError('required') && submitted" role="alert">{{
                                'USER_DETAILS.Q1.REQUIRED2' | translate }}</label>
                            <label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
                                *ngIf="userDetails.get('lastName').hasError('pattern') && submitted" role="alert">{{
                                'COMMON.GENERAL_PATTERN_ERROR' | translate }}</label>
                        </div>
                    </div>
                    <div class="d-flex justify-content-md-end justify-content-center mt-5">
                        <button type="submit" class="app-button"
                            [ngClass]="{'button-primary': userDetails.valid && qID=='1', 'button-primary-disabled': !(userDetails.valid && qID=='1')}"
                            tabindex="0">{{"COMMON.PROCEED"|translate}}</button>
                    </div>
                </div>
            </question>
            <question [qID]="'2'">
                <div class="mx-4 mt-md-0 mt-5">
                    <div class="mb-4 text-md-right text-center">
                        <h1 class="app-title-xxxlarge-blue">{{"USER_DETAILS.Q2.QUESTION"|translate}}</h1>
                    </div>
                    <div class="row justify-content-md-start justify-content-center mb-4">
                        <!--id field-->
                        <div class="col-lg-3 col-md-6 col-sm-12 input-wrapper" aria-live="assertlive">
                            <app-animated-input [maxLength]="9" formControlName="idNumber"
                                placeholder="{{ 'USER_DETAILS.Q2.PH1' | translate }}" [animatedLabel]="true"
                                [attAriaLabel]="'USER_DETAILS.Q2.PH1'|translate" #idNumber></app-animated-input>

                            <label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
                                *ngIf="userDetails.get('idNumber').hasError('required') && submitted" role="alert">{{
                                'COMMON.FIELD_REQUIRED' | translate }}</label>
                            <label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
                                *ngIf="(userDetails.get('idNumber').hasError('invalidId') || userDetails.get('idNumber').hasError('minlength'))&& !userDetails.get('idNumber').hasError('required') && submitted"
                                role="alert">{{ 'COMMON.ID_PATTERN_ERROR' | translate }}</label>
                        </div>
                    </div>
                    <div class="d-flex justify-content-md-end justify-content-center mt-5">
                        <button type="submit" class="app-button"
                            [ngClass]="{'button-primary': userDetails.valid, 'button-primary-disabled': !(userDetails.valid && qID=='2')}"
                            tabindex="0">{{"COMMON.PROCEED"|translate}}</button>
                    </div>
                </div>
            </question>
            <question [qID]="'3'">
                <div class="mx-4 mt-md-0 mt-5">
                    <label class="max-width-page" tabindex="0" data-id="qID3a">
                        <div class="mb-4 text-md-right text-center">
                            <h1 class="app-title-xxxlarge-blue d-inline">{{"USER_DETAILS.Q3.QUESTION"|translate}}</h1>
                        </div>
                    </label>
                    <div class="row justify-content-md-start justify-content-center mb-4">
                        <div class="col-md-3 col-lg-3 col-md-5 input-wrapper m-datepicker" aria-live="assertlive">
                            <app-date-picker formControlName="birthDate" [minDate]="minBirthDate"
                                [maxDate]="maxBirthDate" firstDayOfWeek=7 placeholder="dd/mm/yyyy"
                                attAriaLabel="{{'USER_DETAILS.Q3.BIRTH_DATE'|translate}}" #birthDate
                                (onUpdate)="onDateUpdate($event)"></app-date-picker>
                            <label
                                class="app-error d-md-flex justify-content-md-end text-center text-md-right mr-md-2 mr-0"
                                *ngIf="userDetails.get('birthDate').hasError('required') && submitted" role="alert">{{
                                'COMMON.FIELD_REQUIRED' | translate }}</label>
                            <label
                                class="app-error d-md-flex justify-content-md-end text-center text-md-right mr-md-2 mr-0"
                                *ngIf="userDetails.get('birthDate').hasError('invalidDate') && !userDetails.get('birthDate').hasError('required') && submitted"
                                role="alert">{{ 'COMMON.DATE_ERROR' | translate }}</label>
                        </div>


                    </div>
                    <div class="d-flex justify-content-md-end justify-content-center mt-5">
                        <button type="submit" class="app-button"
                            [ngClass]="{'button-primary': userDetails.valid && qID=='3', 'button-primary-disabled': !(userDetails.valid && qID=='3')}"
                            tabindex="0" data-qid="3">{{"COMMON.PROCEED"|translate}}</button>
                    </div>
                </div>
            </question>
            <question [qID]="'4'">
                <div *ngIf="!isloading1 && !otpService.confirmCode"
                    class="mb-4 text-md-right text-center mr-md-3 mr-sm-1 mt-md-0 mt-5">
                    <h1 class="app-title-xxxlarge-blue">{{"USER_DETAILS.Q4.QUESTION"|translate}}</h1>
                    <div class="d-flex justify-content-center justify-content-md-start text-center text-md-right">
                        <inner-tooltip [qTitle]="'USER_DETAILS.Q4.TOOLTIP'|translate"
                            [text]="'USER_DETAILS.Q4.TOOLTIP_TEXT'|translate"
                            class="m-start-tooltip app-title-small-blue"></inner-tooltip>
                    </div>

                </div>
                <div *ngIf="!isloading1">
                    <div *ngIf="!otpService.confirmCode"
                        class="d-flex justify-content-md-start justify-content-center mb-4">
                        <div class="m-1 input-wrapper mr-md-3 mr-0" aria-live="assertlive">
                            <phone-number [customClass]="'user-details'" formControlName="phoneNumber"
                                [mobilePrefixOnly]="isMobilePrefixOnly" [(isMobile)]="isMobilePhone"
                                (change)="updateValidators($event.target.value)"
                                [ariaLabel]="'HELP_DIALOG.PHONE_NUMBER_PC' | translate"
                                [ariaLabelPre]="'HELP_DIALOG.PHONE_NUMBER_PC_PRE' | translate"
                                [attr.aria-invalid]="!userDetails.get('phoneNumber').valid && submitted" tabindex="0"
                                (onCompleteFill)="onCompleteFill($event)">
                            </phone-number>
                            <label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
                                *ngIf="userDetails.get('phoneNumber').hasError('required') && submitted" role="alert">{{
                                'COMMON.FIELD_REQUIRED' | translate }}</label>
                            <label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
                                *ngIf="userDetails.get('phoneNumber').hasError('minlength') && !userDetails.get('phoneNumber').hasError('required') && submitted"
                                role="alert">{{ 'COMMON.PHONE_MIN_CHARS' | translate }}</label>
                            <label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
                                *ngIf="userDetails.get('phoneNumber').hasError('pattern') && !userDetails.get('phoneNumber').hasError('required') && submitted"
                                role="alert">{{ 'COMMON.PHONE_NUM_PATTERN_ERROR' | translate }}</label>
                        </div>
                    </div>
                    <div *ngIf="!otpService.phoneOk" class="d-flex justify-content-md-end justify-content-center mt-5">
                        <button type="submit" class="app-button"
                            [ngClass]="{'button-primary': userDetails.valid && qID=='4', 'button-primary-disabled': !(userDetails.valid && qID=='4')}"
                            tabindex="0"
                            (click)="continueWithPhoneNum(qID, userDetails.get('phoneNumber').value)">{{"COMMON.PROCEED"|translate}}</button>
                    </div>
                    <app-otp [phoneNumber]="userDetails.get('phoneNumber').value" (submitCb)="onSubmit(userDetails)"
                        class="text-right" *ngIf="otpService.isNewForm">
                    </app-otp>
                </div>


            </question>

            <question [qID]="'4.5'">
                <!-- <app-otp class="text-right" *ngIf="otpService.isNewForm">
				</app-otp> -->
                <!-- <div *ngIf="!otpService.isNewForm"> -->
                <app-messages *ngIf="isDisplayed" [msgArr]="errorMessageOnComponent"></app-messages>
                <button *ngIf="buttonGoContinueProcess" (click)="goContinueProcess()"
                    class="mt-3 app-button button-primary btn-lg m-start-btn">
                    <div>{{'USER_DETAILS.Q4.GO_TO_CONTINUE-PROCESS' | translate}}</div>
                </button>
                <div class="mx-4 mt-md-0 mt-5">
                    <div class="mb-4 text-lg-right text-md-center text-center">
                        <h1 class="app-title-xxxlarge-blue">{{"USER_DETAILS.Q4-5.QUESTION"|translate}}</h1>
                        <h5 class="app-text-bold" *ngIf="isAdvisor">{{"USER_DETAILS.Q4-5.TEXT"|translate}}</h5>
                    </div>
                    <div class="row justify-content-lg-start justify-content-center mb-4 mr-0">
                        <!--id field-->
                        <div class="col-lg-3 col-md-6 col-sm-12 p-0" aria-live="assertlive">
                            <app-animated-input formControlName="email"
                                placeholder="{{ 'USER_DETAILS.Q4-5.LABEL' | translate }}" [hasCurrencyMask]="false"
                                [animatedLabel]="true" [hasTitle]="false"
                                [attAriaLabel]="'USER_DETAILS.Q4-5.LABEL'|translate" #email></app-animated-input>
                            <label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
                                *ngIf="userDetails.get('email').hasError('required') && submitted" role="alert">{{
                                'COMMON.FIELD_REQUIRED' | translate }}</label>
                            <label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
                                *ngIf="userDetails.get('email').hasError('pattern') && !userDetails.get('email').hasError('required') && submitted"
                                role="alert">{{ "COMMON.EMAIL_PATTERN_ERROR" | translate }}</label>
                        </div>
                    </div>
                    <div class="d-flex justify-content-md-end justify-content-center mt-5">
                        <button *ngIf="!buttonGoContinueProcess" type="submit" class="app-button"
                            [ngClass]="{'button-primary': userDetails.valid && qID=='4.5', 'button-primary-disabled': !(userDetails.valid && qID=='4.5')}"
                            tabindex="0">{{"COMMON.PROCEED"|translate}}</button>
                    </div>
                </div>
                <div class="mx-4 mt-md-0 mt-5">
                    <app-loader-page [isloading]="isloading1"></app-loader-page>
                </div>
                <!-- </div> -->
            </question>

            <question [qID]="'5'">
                <div class="mx-4 mt-md-0 mt-5">
                    <div class="mb-4 text-lg-right text-md-center text-center">
                        <h1 class="app-title-xxxlarge-blue">{{"USER_DETAILS.Q5.QUESTION"|translate}}</h1>
                    </div>
                    <div class="row justify-content-lg-start justify-content-center mb-4 mr-0 pr-3 pr-md-0">
                        <!--text field-->
                        <div class="col-lg-3 col-md-6 col-sm-12 input-wrapper pr-0" aria-live="assertlive">
                            <app-dplist-new [valueArr]='status' formControlName="maritalStatus" [asyncData]="false"
                                [atrrAriaLabel]="'USER_DETAILS.Q5.LABEL'|translate" tabindex="0"
                                (change)="dpListSelectChange($event)" (onCompleteFill)="onCompleteFill($event)">
                            </app-dplist-new>
                            <label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
                                *ngIf="userDetails.get('maritalStatus').hasError('required') && submitted"
                                role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
                        </div>
                    </div>
                    <div class="d-flex justify-content-md-end justify-content-center mt-5">
                        <button type="submit" class="app-button"
                            [ngClass]="{'button-primary': userDetails.valid && qID=='5', 'button-primary-disabled': !(userDetails.valid && qID=='5')}"
                            tabindex="0">{{"COMMON.PROCEED"|translate}}</button>
                    </div>
                </div>
            </question>
            <question [qID]="'6'">
                <div *ngIf="!isloading2" class="mx-4 mt-md-0 mt-5">
                    <div class="mb-4 text-md-right text-center">
                        <app-messages *ngIf="isDisplayed6" [msgArr]="errorMessageOnComponent6"></app-messages>
                        <app-messages *ngIf="isDisplayed" [msgArr]="errorMessageOnComponent"></app-messages>
                        <h1 class="app-title-xxxlarge-blue">{{"USER_DETAILS.Q6.QUESTION"|translate}}</h1>
                    </div>
                    <div class="btn-group-toggle d-flex flex-column flex-md-row justify-content-md-start justify-content-center"
                        data-toggle="buttons" aria-live="assertlive">
                        <label class="app-label button-secondary-disabled"
                            [ngClass]="{'selected':userDetails.get('areThereAdditionalBorrowers').value==='YES'}"
                            tabindex="0" data-id="qID6a" data-fieldName="areThereAdditionalBorrowers"
                            data-fieldValue="YES">
                            {{"COMMON.YES"|translate}}
                            <input class="radio" type="radio" (click)="offLoader()"
                                formControlName="areThereAdditionalBorrowers" value="YES"
                                (change)="onSubmit(userDetails)" click2change tabindex="-1">
                        </label>
                        <label class="app-label button-secondary-disabled mr-md-3 mt-3 mt-md-0"
                            [ngClass]="{'selected':userDetails.get('areThereAdditionalBorrowers').value==='NO'}"
                            tabindex="0" data-id="qID6b" data-fieldName="areThereAdditionalBorrowers"
                            data-fieldValue="NO">
                            {{"COMMON.NO"|translate}}
                            <input class="radio" type="radio" formControlName="areThereAdditionalBorrowers" value="NO"
                                (change)="onSubmit(userDetails)" click2change tabindex="-1">
                        </label>
                    </div>
                </div>
                <div class="mx-4 mt-md-0 mt-5">
                    <app-loader-page [isloading]="isloading2"></app-loader-page>
                </div>
            </question>
            <question [qID]="'7'">
                <app-messages *ngIf="isDisplayed7" [msgArr]="errorMessageOnComponent7"></app-messages>
                <app-messages *ngIf="isDisplayed && !isloading3" [msgArr]="errorMessageOnComponentBorrower">
                </app-messages>
                <h1 *ngIf="!isloading3" class="d-flex justify-content-center mt-md-0 mt-5">
                    {{"USER_DETAILS.Q7.QUESTION"|translate}}</h1>
                <app-borrowers-array (offError)="offError()" [msgArr]="arrayErrorMsgCheckBorrower"
                    [customerIdNumberFormControl]="userDetails.get('idNumber')"
                    [ifShowMessages]="isDisplayed && !isloading3" *ngIf="!isloading3" formArrayName="borrowersArray"
                    (failedAddBorrowersCause)="failedAddBorrowersCause($event)" (errorMsg)="addBorrowerError()"
                    (onAddFormGroup)="setValidators()" [qID]="7" [borrowersArray]="userDetails.get('borrowersArray')"
                    [displayErrors]="submitted" [showRemove]="editQuestion != '7' && qID=='7'"
                    [attAriaLabel]="'USER_DETAILS.Q7.BORROWERS_FORM'|translate">
                </app-borrowers-array>

                <div *ngIf="!isloading3" class="mt-3 d-flex justify-content-center text-center">
                    <button type="submit" class="app-button"
                        [ngClass]="{'button-primary': userDetails.valid && qID=='7', 'button-primary-disabled': !(userDetails.valid && qID=='7')}">{{"COMMON.PROCEED"|translate}}</button>
                </div>
                <div class="mx-4 mt-md-0 mt-5">
                    <app-loader-page [isloading]="isloading3"></app-loader-page>
                </div>

            </question>
        </questions-manager>
    </div>
</form>


// WEBPACK FOOTER //
// ./src/app/user-details/user-details.component.html